"use client";

import { SLATE_XP_REDRAWN_ICONS_ALPHA } from "@faire/web/slate/icons/lib/SLATE_XP_REDRAWN_ICONS";

import { Checkmark as CheckmarkControl } from "./__internal__/Checkmark.control";
import { Checkmark as CheckmarkTreatment } from "./__internal__/Checkmark.treatment";

/**
 * @deprecated use Check from `@faire/slate/icons/Check`
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const Checkmark = SLATE_XP_REDRAWN_ICONS_ALPHA.icon({
  control: CheckmarkControl,
  treatment: CheckmarkTreatment,
});
